import { addType, editType } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {}
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('类型名称')
        }],
        sort: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('排序')
        }]
      };
    }
  },
  methods: {
    init(data) {
      if (data.organizationId) {
        this.dataFrom = {
          name: data.name,
          sort: data.sort,
          organizationId: data.organizationId
        };
      }
      if (data.customerId) {
        this.dataFrom.customerId = data.customerId;
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.organizationId ? editType : addType;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok', res);
            this.$emit('cancel');
          });
        }
      });
    }
  }
};